import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { retrievePageMenu } from "../../../redux/slice/page-menu.slice";
import { useAppDispatch, RootState } from "../../../redux/store";
import { useDynamicScripts } from "../../../hooks/useDynamicScript";
import LoadingComp from "../../../components/re-usable/loading/loading";
import PageNotFound from "../../errors/page-not-found";
import ContainerLayout from "../../../layouts/two-columns/container-layout";

const TopicalPages = () => {
  const param = useParams();
  const path = `%2Fresources%2Ftopic%2F${param.pageName}`;

  const dispatch = useAppDispatch();
  const { RapsEuropeData, RapsEuropeLoading: pageMenuLoading, pageNotFound } = useSelector((state: RootState) => state.rapsEurope);

  const [isPublished, setIsPublished] = useState(false);
  const [isPageNotFound, setIsPageNotFound] = useState(!pageMenuLoading && pageNotFound);

  const [scriptHtmlString, setScriptHtmlString] = useState("");

  useEffect(() => {
    dispatch(retrievePageMenu(path));
  }, [dispatch]);

  useEffect(() => {
    if (!pageMenuLoading && pageNotFound) {
      setIsPageNotFound(true);
    }
    else if (RapsEuropeData[0]) {
      setIsPublished(true);
    }
  }, [RapsEuropeData]);

  useEffect(() => {
    if (isPublished) {
      if (RapsEuropeData[0].result[0]?.javaScriptField)
        setScriptHtmlString(RapsEuropeData[0].result[0]?.javaScriptField);
    }
    if (typeof window !== "undefined" && window.runGlobalScripts) {
      window.runGlobalScripts();
    }
  }, [isPublished])

  useDynamicScripts({ htmlScriptString: scriptHtmlString });

  if (isPageNotFound) return <PageNotFound />;
  if (!isPublished) return <LoadingComp />;

  return (
    <>
      <Helmet>
        <title>{RapsEuropeData[0]?.result[0]?.menuItemName}</title>
      </Helmet>
      <ContainerLayout breadcrumbPath={path} isBreadcrumbPath={false} showAds={true}>
        <div dangerouslySetInnerHTML={{ __html: RapsEuropeData[0]?.result[0]?.description }}></div>
        {/*<ContentListingComponent path={path} />*/}
        <div dangerouslySetInnerHTML={{ __html: RapsEuropeData[0]?.result[0]?.councilDescription }}></div>
        <div dangerouslySetInnerHTML={{ __html: RapsEuropeData[0]?.result[0]?.popupContent }}></div>
      </ContainerLayout>
    </>
  );
};

export default TopicalPages;
